var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-settings-section",attrs:{"id":_vm.htmlId}},[_c('h3',{staticClass:"app-settings-section__title"},[_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t")]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }